import { http } from '../../../../api/http';
import type { OrdenLiquidacion } from '../types';

export class OrdenLiquidacionService {
  private static readonly BASE_URL = '/produccion/ordenliquidacion';

  static async getAll(): Promise<OrdenLiquidacion[]> {
    try {
      const response = await http.get(`${this.BASE_URL}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching órdenes de liquidación:', error);
      throw error;
    }
  }

  static async getByEstado(estado: string): Promise<OrdenLiquidacion[]> {
    try {
      const response = await http.get(`${this.BASE_URL}/estado/${estado}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching órdenes por estado ${estado}:`, error);
      throw error;
    }
  }

  static async getById(id: number): Promise<OrdenLiquidacion> {
    try {
      const response = await http.get(`${this.BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching orden ${id}:`, error);
      throw error;
    }
  }

  static async generar(idGuiaProduccion: number): Promise<OrdenLiquidacion> {
    try {
      const response = await http.post(`${this.BASE_URL}/generar/${idGuiaProduccion}`);
      return response.data;
    } catch (error) {
      console.error('Error generando orden de liquidación:', error);
      throw error;
    }
  }

  static async updateEstado(id: number, estado: string): Promise<void> {
    try {
      await http.put(`${this.BASE_URL}/${id}/estado/${estado}`);
    } catch (error) {
      console.error(`Error actualizando estado de orden ${id}:`, error);
      throw error;
    }
  }

  static async delete(id: number): Promise<void> {
    try {
      await http.delete(`${this.BASE_URL}/${id}`);
    } catch (error) {
      console.error(`Error eliminando orden ${id}:`, error);
      throw error;
    }
  }
}
